var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.COMMUNICATION.TITLE")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("dl", { staticClass: "view_subject" }, [
              _c("dt", { staticClass: "subject qna_view" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.result.TITLE) +
                    "\n                            "
                ),
                _c("span", { staticClass: "in_date" }, [
                  _vm._v(_vm._s(_vm.result.REG_DT))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "view_qna_desc" },
              [
                _vm._l(_vm.commentList, function(reply) {
                  return _c(
                    "dl",
                    {
                      key:
                        _vm.pageName +
                        reply.QUESTION_FLOW_ID +
                        reply.COMMENT_SEQ,
                      class: "Y" === reply.ANSWERER_YN ? "" : "reply"
                    },
                    [
                      _c("dt", [
                        "Y" === reply.ANSWERER_YN
                          ? _c("span", { staticClass: "item_status" }, [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.EXPERT.ANSWER")) + "ed by"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "item_name" }, [
                          _vm._v(_vm._s(reply.REG_USER_NAME))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "item_date" }, [
                          _vm._v(_vm._s(reply.REG_DT))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.getMessage(reply.MESSAGE))
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "in_btn_wrap" }, [
                          !_vm.isMobile()
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn_sm_white",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.translationPop(reply.MESSAGE)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t("FIELD.GLOBAL.TRANSLATION")
                                      ) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.mainPopYn
                  ? _c("dl", { staticClass: "reply_write_wrap reply" }, [
                      _c("dt", { attrs: { "data-input-type": "textarea" } }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.comment,
                              expression: "comment"
                            }
                          ],
                          staticClass: "textarea_ty w100p",
                          attrs: { maxlength: "3000" },
                          domProps: { value: _vm.comment },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.comment = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "textarea_counter" }, [
                          _vm._v(_vm._s(_vm.commentLength) + "/3000")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c(
                          "a",
                          {
                            staticClass: "btn_reply",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.replyComment("replyComment")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("BUTTON.MYKNOWLEDGE.REPLY")) +
                                "\n                                "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-267e2aa3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267e2aa3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/communicationPopup.vue
// module id = 2cSl
// module chunks = 0